module.exports = __webpack_public_path__ + "static/media/Pre&post_form.76b8b317.png";